import Router from "./routes/Routes";
import Header from "./main/Header";

import "./index.scss";

import "./assets/css/home.scss";

import Footer from "./main/Footer";
import { useLocation } from "react-router-dom";
export default function Main() {
  const location = useLocation();
  if (location.pathname.includes("/admin-panel/reservation/lists/")) {
    return <Router> </Router>;
  }
  return (
    <>
      <Header></Header>
      <Router> </Router>
      <Footer></Footer>
    </>
  );
}
